<template>
  <el-dialog
    title="Add new owner"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <el-container>
      <el-main>
        <el-form v-loading="fetchInProgress">
          <el-form-item
            label="E-mail"
            :class="{ 'is-error': errors.email.length > 0 }"
          >
            <el-input
              ref="input"
              v-model="form.email"
              @keydown.enter.native.prevent="submit"
            />
            <div
              v-for="error in errors.email"
              :key="error"
              class="el-form-item__error"
            >
              {{ error }}
            </div>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="submit()">
          Create
        </el-button>
        <el-button @click="close()">
          Cancel
        </el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
import { normalizeEmail } from 'utils'

export default {
  props: {
    organizationId: {
      type: String,
      default: '',
    },
    currentOwnerEmails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      fetchInProgress: false,
      form: { email: '' },
      errors: {
        email: [],
      },
      userAlreadyExists: false,
      user: { id: null, email: null, role: null },
    }
  },
  computed: {
    hasErrors() {
      return this.errors.email.length > 0
    },
  },

  methods: {
    open() {
      this.visible = true
      this.form.email = ''
      this.userAlreadyExists = false
      this.user = { id: null, email: null, role: null }
      this.errors = { email: [] }
      const self = this
      setTimeout(function () {
        self.$refs.input.focus()
      }, 200)
    },

    async submit() {
      const email = this.form.email
      if (this.isAlreadyAnOwner(email)) {
        this.errors.email = ['This user is already an owner']
        return
      }
      this.saveOwner()
    },

    async saveOwner() {
      try {
        const owner = await this.$store.dispatch('adminOwnerList/create', {
          email: this.form.email,
          orgId: this.organizationId,
        })
        this.$emit('added', { owner })
        this.close()
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors = error.response.data
        }
      } finally {
      }
    },

    async promoteInvestorToOrganizer() {
      const owner = await this.$store.dispatch(
        'adminOwnerList/promoteInvestor',
        {
          email: this.form.email,
          orgId: this.organizationId,
        },
      )
      this.$emit('added', { owner })
    },

    close() {
      this.visible = false
    },

    isAlreadyAnOwner(email) {
      const currentOwners = new Set()
      this.currentOwnerEmails.forEach((email) =>
        currentOwners.add(normalizeEmail(email)),
      )
      return currentOwners.has(normalizeEmail(email))
    },
  },
}
</script>
